const openedDrawerOrders = new Set<string>();

export function markDrawerOpened(orderKey: string | undefined): void {
  if (orderKey) openedDrawerOrders.add(orderKey);
}

export function wasDrawerOpened(orderKey: string | undefined): boolean {
  return !!orderKey && openedDrawerOrders.has(orderKey);
}
